"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFamilyMembers = addFamilyMembers;
exports.callPatientProfileListApi = callPatientProfileListApi;
exports.checkPatientInAkhilHis = checkPatientInAkhilHis;
exports.checkPatientInHis = checkPatientInHis;
exports.completeProfile = completeProfile;
exports.deleteProfile = deleteProfile;
exports.editProfile = editProfile;
exports.familyMember = familyMember;
exports.getGuestUserRegistrationStatus = getGuestUserRegistrationStatus;
exports.getPatientProfile = getPatientProfile;
exports.guestCheckoutAddUserInfo = guestCheckoutAddUserInfo;
exports.guestCheckoutRegister = guestCheckoutRegister;
var _genericFetch = _interopRequireWildcard(require("../../../../common/api/genericFetch"));
var _ApiConst = require("../../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../../common/api/api';

function completeProfile(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.COMPLETE_PATIENT_PROIFLE_INFO}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function guestCheckoutRegister(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.API_MYASTER_URL}${_ApiConst.GUEST_CHECKOUT_REGISTER}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function getPatientProfile(requestParams, tokenData) {
  let queryString = '?';
  if ('_query' in requestParams) {
    for (const key in requestParams) {
      if (queryString === '?') {
        queryString = queryString + key + '=' + requestParams[key];
      } else {
        queryString = queryString + '&' + key + '=' + requestParams[key];
      }
    }
  } else {
    queryString = requestParams.userId;
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.COMPLETE_PATIENT_PROIFLE_INFO}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callPatientProfileListApi(phone, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_PATIENT_PROIFLE_LIST}${phone}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function editProfile(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.COMPLETE_PATIENT_PROIFLE_INFO}${requestParams.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.PUT });
}
function deleteProfile(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.COMPLETE_PATIENT_PROIFLE_INFO}${requestParams.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.DELETE });
}
function checkPatientInHis(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CHECK_PATIENT_IN_HIS_API}${requestParams}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function checkPatientInAkhilHis(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CHECK_PATIENT_IN_AKHILHIS_API}/${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function familyMember(mobile, tokenData) {
  const apiEndPoint = `${_ApiConst.FAMILY_MEMBER}${mobile}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function addFamilyMembers(requestParams, tokenData) {
  const {
    id,
    body
  } = requestParams === null || requestParams === void 0 ? void 0 : requestParams.params;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.ADD_MEMBERS}${id}/${_ApiConst.ASSOCIATED_PROFILE}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = body;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function guestCheckoutAddUserInfo(requestParams, tokenData) {
  const {
    id,
    data
  } = requestParams === null || requestParams === void 0 ? void 0 : requestParams.params;
  const apiEndPoint = `${_ApiConst.API_MYASTER_URL}${_ApiConst.IDENTITY_SERVICE_BASE_URL}${id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = data;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.PUT });
}
function getGuestUserRegistrationStatus(userId, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.IDENTITY_SERVICE_BASE_URL}${userId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}